










import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ComponentAltaPrioridadeBadge extends Vue {
  @Prop({ default: { id: '', altaPrioridade: false }, required: true }) item: any
}
